import AccountingMetabaseEmbed from './components/AccountingMetabaseEmbed';

const OverviewPage = () => {
  return (
    <AccountingMetabaseEmbed />
  );
};

export default OverviewPage;
